import Control from "./Control.js"

export default class Toggle extends Control {

  constructor(props, context) {
    super(props, context)
    this.state.toggled = false
    this.state.onlabel = ""
    this.state.offlabel = ""
  }

  static get contextTypes() {
    return super.contextTypes
  }

  set toggled(value) {
    if (value === this.state.toggled)
      return value

    this.setState({toggled: value})
    this.change(value)
  }

  get toggled() {
    return this.state.toggled
  }

  get propsList() {
    const props = super.propsList
    props["aria-checked"] = this.state.toggled
    props["role"] = "switch"
    return props
  }

  toggle() {
    return this.toggled = !this.toggled
  }

  onClick(event) {
    this.toggle()
  }
}
